import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './App.css';

import Main from './Components/Main';

export default function App() { return ( <Main /> ); }
